module.exports = __webpack_public_path__ + "img/7.ec02ecf4.jpg";